// Loads another page, e.g. a provider's sign-in or the app afresh once the account is gone. Never settles: whatever
// waits on it, e.g. a dialog's button, stays as it is until the browser has left.
const leavePage = (url: string) => {
    window.location.assign(url);
    return new Promise<never>(() => {});
};

export default leavePage;
